export { default as BackgroundTypeGradient } from './gradient/index';
export { default as BackgroundTypeGradientSave } from './gradient/save';
export { default as BackgroundTypeColor } from './background-color/index';
export { default as BackgroundTypeBackgroundColorSave } from './background-color/save';
export { default as BackgroundTypeImage } from './background-image/index';
export { default as BackgroundTypeImageSave } from './background-image/save';
export { default as BackgroundTypeImageAndColor } from './background-image-color/index';
export { default as BackgroundTypeImageAndColorSave } from './background-image-color/save';
export { default as ImageAsBackground } from './image-as-background/index';
export { default as ImageAsBackgroundSave } from './image-as-background/save';
export { default as ImageGradient } from './gradient-image/index';
export { default as ImageGradientSave } from './gradient-image/save';
export { default as BackgroundVideo } from './background-video/index';
export { default as BackgroundVideoSave } from './background-video/save';

export const ImageAsBackgroundSaveBlock = (props) => {
  const { imageAsBackgroundOptions, devices, classNames } = props;
  return (
    <div className={classNames}>
      <picture>
        {devices.toReversed().map((device, i) => {
          const deviceType = device.type;
          const elementKey = `${deviceType}-${i}`;
          if (imageAsBackgroundOptions[deviceType]?.settings.url === '')
            return null;

          const { url, alt } =
            imageAsBackgroundOptions[deviceType]?.settings || {};

          if (deviceType === 'desktop') {
            return <img src={url} key={elementKey} alt={alt} />;
          }
          return (
            <source
              srcSet={url}
              media={`(max-width:${imageAsBackgroundOptions[deviceType].breakpoint}px)`}
              key={elementKey}
            ></source>
          );
        })}
      </picture>
    </div>
  );
};
